import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import PhoneLink from "@/components/PhoneLink";
import logo from "@/assets/logo.png";

const services = [
  { label: "Auto Insurance", href: "/services/auto-insurance" },
  { label: "Homeowners Insurance", href: "/services/homeowners-insurance" },
  { label: "Commercial Insurance", href: "/services/commercial-insurance" },
  { label: "Health Insurance", href: "/services/health-insurance" },
  { label: "Life Insurance", href: "/services/life-insurance" },
  { label: "Group Benefits", href: "/services/group-benefits" },
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-surface/95 backdrop-blur-md shadow-card">
      <div className="container flex items-center justify-between h-24 md:h-28">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="Mom & Pop Insurance Shop" className="h-24 md:h-28 w-auto" width="112" height="112" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-1">
          <Link to="/" className="px-3 py-2 text-sm font-medium text-foreground hover:text-primary transition-colors">
            Home
          </Link>
          <Link to="/about" className="px-3 py-2 text-sm font-medium text-foreground hover:text-primary transition-colors">
            About
          </Link>
          <div className="relative group">
            <button
              className="px-3 py-2 text-sm font-medium text-foreground hover:text-primary transition-colors flex items-center gap-1"
              onMouseEnter={() => setServicesOpen(true)}
              onMouseLeave={() => setServicesOpen(false)}
            >
              Services <ChevronDown className="w-3.5 h-3.5" />
            </button>
            {servicesOpen && (
              <div
                className="absolute top-full left-0 pt-1"
                onMouseEnter={() => setServicesOpen(true)}
                onMouseLeave={() => setServicesOpen(false)}
              >
                <div className="bg-surface rounded-xl shadow-elevated p-2 min-w-[220px]">
                  {services.map((s) => (
                    <Link
                      key={s.href}
                      to={s.href}
                      className="block px-3 py-2 text-sm text-foreground hover:bg-muted rounded-lg transition-colors"
                    >
                      {s.label}
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
          <Link to="/cities" className="px-3 py-2 text-sm font-medium text-foreground hover:text-primary transition-colors">
            Areas We Serve
          </Link>
          <Link to="/blog" className="px-3 py-2 text-sm font-medium text-foreground hover:text-primary transition-colors">
            Blog
          </Link>
          <Link to="/contact" className="px-3 py-2 text-sm font-medium text-foreground hover:text-primary transition-colors">
            Contact
          </Link>
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <PhoneLink location="header" className="text-sm font-medium text-muted-foreground hover:text-foreground" />
          <Button asChild>
            <Link to="/quote">Get My Free Quote</Link>
          </Button>
        </div>

        {/* Mobile toggle */}
        <button
          className="lg:hidden p-2 -mr-2"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="lg:hidden border-t bg-surface pb-4">
          <nav className="container flex flex-col gap-1 pt-3">
            <Link to="/" onClick={() => setMobileOpen(false)} className="px-3 py-3 text-sm font-medium text-foreground rounded-lg hover:bg-muted">Home</Link>
            <Link to="/about" onClick={() => setMobileOpen(false)} className="px-3 py-3 text-sm font-medium text-foreground rounded-lg hover:bg-muted">About</Link>
            {services.map((s) => (
              <Link key={s.href} to={s.href} onClick={() => setMobileOpen(false)} className="px-3 py-3 text-sm font-medium text-foreground rounded-lg hover:bg-muted pl-6">
                {s.label}
              </Link>
            ))}
            <Link to="/cities" onClick={() => setMobileOpen(false)} className="px-3 py-3 text-sm font-medium text-foreground rounded-lg hover:bg-muted">Areas We Serve</Link>
            <Link to="/blog" onClick={() => setMobileOpen(false)} className="px-3 py-3 text-sm font-medium text-foreground rounded-lg hover:bg-muted">Blog</Link>
            <Link to="/contact" onClick={() => setMobileOpen(false)} className="px-3 py-3 text-sm font-medium text-foreground rounded-lg hover:bg-muted">Contact</Link>
            <div className="pt-2 px-3">
              <Button asChild className="w-full">
                <Link to="/quote" onClick={() => setMobileOpen(false)}>Get My Free Quote</Link>
              </Button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
